import { isString, ObjectAccessor } from '@dateam/ark';
import { parseObservationField } from './shared';
import { RecordValue, ValidationError } from './types';

/*
 ** Adventices secondaires
 ** - field1
 **     Liste Adventice (données de référence, la saisie alimente la liste)
 ** - field2
 **     Liste Adventice (données de référence, la saisie alimente la liste)
 ** - field3
 **     Liste Adventice (données de référence, la saisie alimente la liste)
 */

type CurrentObservation = App.Observation6;
type CurrentApiObservation = App.Api.Observation6;

export const validate = (
    observation: CurrentObservation,
    _: App.Plot
): Record<never, never> | Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError> => {
    const validation = {} as Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError>;

    const {
        ignored,
        field1,
        field2,
        field3
    } = observation;

    if (ignored === true) return validation;

    if (field1 != null && !isString(field1)) {
        validation.field1 = {
            field: 'field1',
            type: 'error',
            code: 'format'
        };
    }

    if (field2 != null && !isString(field2)) {
        validation.field2 = {
            field: 'field2',
            type: 'error',
            code: 'format'
        };
    }

    if (field3 != null && !isString(field3)) {
        validation.field3 = {
            field: 'field3',
            type: 'error',
            code: 'format'
        };
    }

    return validation;
};

export const parse = (observation: CurrentApiObservation): CurrentObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        field1,
        field2,
        field3
    } = observation;
    const parsedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        isSyncing: false,
        isValid: true,
        hasChanged: false
    } as CurrentObservation;

    parsedObs.field1 = parseObservationField(field1);
    parsedObs.field2 = parseObservationField(field2);
    parsedObs.field3 = parseObservationField(field3);

    return parsedObs;
};

export const map = (observation: CurrentObservation): CurrentApiObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        field1,
        field2,
        field3
    } = observation;
    const mappedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn
    } as CurrentApiObservation;

    mappedObs.field1 = field1 !== undefined ? new RecordValue(field1) : null;
    mappedObs.field2 = field2 !== undefined ? new RecordValue(field2) : null;
    mappedObs.field3 = field3 !== undefined ? new RecordValue(field3) : null;

    return mappedObs;
};